import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { dashboardAPI } from "../../../../Api/dashboardAPI";
import { DashboardInitState } from "../../Slices/dashboardSlice";
import { ToastMessage, toastError } from "../../../../utils/toast";

export const validateToken = createAsyncThunk(
  "dashboard/validateToken",
  async (token: string, thunkAPI) => {
    try {
      console.log(`Validating token...`);
      const response = await dashboardAPI.validateToken(token);
      return response;
    } catch (error: any) {
      console.error("Error validating token:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const validateTokenBuilder = (
  builder: ActionReducerMapBuilder<DashboardInitState>
) => {
  builder.addCase(validateToken.pending, (state) => {
    state.loadingPageScreen = true;
    state.tokenValidationStatus = 'pending';
  });
  
  builder.addCase(validateToken.fulfilled, (state) => {
    console.log("validateToken fulfilled");
    state.loadingPageScreen = false;
    state.tokenValidationStatus = 'valid';
  });
  
  builder.addCase(validateToken.rejected, (state, action) => {
    console.log("validateToken rejected:", action.payload);
    state.loadingPageScreen = false;
    state.tokenValidationStatus = 'invalid';
  });
}; 